<app-view-title [isPrimaryColor]="true" Title="{{ 'Intellitrailer.Booking.Components.BookingSummary.Trailer' | translate : 'Trailer'}}: {{ booking.RentalObject?.Alias ?? booking.RentalObject?.Title }}"></app-view-title>

<view-content [centered]="true">
  @if (stepShowPin) {
  @if (!hasPinFailed) {
  <app-card>
    <h2>{{ 'Intellitrailer.Rental.Nuwiel.LockBox.Title1' | translate : 'Open the lockbox' }}</h2>
    <img class="lock-keypad-image" src="/Images/Nuwiel/nuwiel-lock-box.png" />

    @if (isWaitingPin) {
    <p>
      {{ 'Intellitrailer.Rental.Nuwiel.NuwielUnlockWaiting' | translate : 'Please wait while we generate the unlock pin' }}...
    </p>
    } @else {
    <p>
      {{ 'Intellitrailer.Rental.Nuwiel.LockBox.Description2' | translate : 'Enter the PIN below, press the top button, and slide it down to open. Make sure to lock it securley after use.' }}
    </p>

    @if (unlockPin) {
    <div class="unlock-pin">
      <div *ngFor="let pin of unlockPin.split(''); let i = index">
        <span>{{ pin }}</span>
        @if (i !== unlockPin.length - 1) {
        <span class="space"> </span>
        }
      </div>
    </div>
    }

    <a (click)="troubleshootNuwiel()" class="link">{{ 'Intellitrailer.Rental.Nuwiel.TitleLockNotOpen2' | translate : "Lockbox won't open?" }}</a>
    }
  </app-card>
  } @else {
  <app-card>
    @if (failReason == 0) {
    <h2>{{ 'Intellitrailer.Rental.Nuwiel.NuwielPinNotGenerated' | translate : 'Could not find the pin to unlock' }}</h2>
    } @else {
    <h2>{{ 'Intellitrailer.Rental.Nuwiel.TitleLockNotOpen2' | translate : "Lockbox won't open?" }}</h2>
    }

    <p>{{ 'Intellitrailer.Rental.Nuwiel.NuwielNotFoundInfo2' | translate : 'Please make sure you are at the correct trailer.' }}</p>
  </app-card>
  }
  }
  @else if(currentStep) {
  @if (isCheckingLockState) {
  <div class="nuwiel-checking-screen horizontal-vertical-center">
    <mat-progress-spinner diameter="75" mode="indeterminate" class="inverted-spinner"></mat-progress-spinner>
    <h2>{{ 'Intellitrailer.Rental.Nuwiel.Checking.Title1' | translate : 'Please wait while we verify the eTrailer status.' }}...</h2>
  </div>
  }
  @else {
  @switch (currentStep.id) {
  @case ('power-on') {
  <ng-container>
    <app-instruction-slider [secondaryColor]="true"
                            [slides]="powerOnSlides">
    </app-instruction-slider>
  </ng-container>
  }

  @case ('parking-mode-off') {
  <ng-container>
    <app-instruction-slider [secondaryColor]="true"
                            [slides]="parkingModeOffSlides">
    </app-instruction-slider>
  </ng-container>
  }

  @case ('mode-select') {
  <ng-container>
    <app-information-screen [secondaryColor]="true"
                            title="{{ 'Intellitrailer.Rental.Nuwiel.Step.TravelModeSelect1.Title' | translate : 'Select trip mode' }}"
                            primaryContent="{{ 'Intellitrailer.Rental.Nuwiel.Step.TravelModeSelect1.Description' | translate : 'How are you moving today?' }}">
    </app-information-screen>

    <h2>{{ 'Intellitrailer.Rental.Nuwiel.Step.TravelMode1.TitleStep1' | translate : 'Cycling' }}</h2>
    <img class="lock-keypad-image" src="/Images/Nuwiel/nuwiel-bike-mode.jpg" (click)="selectMode('BIKE')" />

    <h2>{{ 'Intellitrailer.Rental.Nuwiel.Step.TravelMode1.TitleStep2' | translate : 'Walking' }}</h2>
    <img class="lock-keypad-image" src="/Images/Nuwiel/nuwiel-hand-mode.jpg" (click)="selectMode('HAND')" />

    <a class="link" (click)="previousStep()">
      {{ 'Intellitrailer.Rental.Nuwiel.cmdPreviousStep' | translate : 'Previous step' }}
    </a>
  </ng-container>
  }

  @case ('move-to-bike') {
  <ng-container>
    <app-instruction-slider [secondaryColor]="true"
                            [slides]="moveToBikeSlides">
    </app-instruction-slider>
  </ng-container>
  }

  @case ('hand-mode-instructions') {
  <ng-container>
    <app-instruction-slider [secondaryColor]="true"
                            [slides]="handCartModeSlides">
    </app-instruction-slider>
  </ng-container>
  }

  @case ('bike-pin') {
  <ng-container>
    <app-instruction-slider [secondaryColor]="true"
                            [slides]="bikeModeSlides">
    </app-instruction-slider>
  </ng-container>
  }

  @case ('parking-mode-select') {
  <ng-container>
    <app-information-screen [secondaryColor]="true"
                            title="{{ 'Intellitrailer.Rental.Nuwiel.Step.ReturnModeSelect.Title' | translate : 'How did you use the eTrailer?' }}">
    </app-information-screen>

    <h2>{{ 'Intellitrailer.Rental.Nuwiel.Mode1.Bike' | translate : 'Cycling' }}</h2>
    <img class="lock-keypad-image" src="/Images/Nuwiel/nuwiel-bike-mode.jpg" (click)="selectParkingModeUsed('BIKE')" />

    <h2>{{ 'Intellitrailer.Rental.Nuwiel.Mode1.Hand' | translate : 'Walking' }}</h2>
    <img class="lock-keypad-image" src="/Images/Nuwiel/nuwiel-hand-mode.jpg" (click)="selectParkingModeUsed('HAND')" />

    <a class="link" (click)="previousStep()">
      {{ 'Intellitrailer.Rental.Nuwiel.cmdPreviousStep' | translate : 'Previous step' }}
    </a>
  </ng-container>
  }

  @case ('parking-mode-on') {
  <ng-container>
    <app-instruction-slider [secondaryColor]="true"
                            [slides]="returnParkingModeSlides">
    </app-instruction-slider>
  </ng-container>
  }

  @case ('power-off') {
  <ng-container>
    <app-instruction-slider [secondaryColor]="true"
                            [slides]="powerOffSlides">
    </app-instruction-slider>
  </ng-container>
  }
  }

  @if (isCheckingLockState && currentStep?.requiresCheck) {
  <div class="step-check-status">
    <a class="link" (click)="continueAfterCheck()">
      {{ ('Intellitrailer.Rental.Nuwiel.ManualContinue.' + currentStep?.id) | translate : getManualContinueText() }}
    </a>
  </div>
  }

  @if (hasCheckFailed) {
  <div class="step-check-status">
    <p class="check-status-text error">
      {{ 'Intellitrailer.Rental.Nuwiel.Checking.TimeoutDescription1' | translate : 'Unable to verify the trailer status. Please try again.' }}
    </p>
  </div>
  }
  }
  }
</view-content>

<view-actions>
  @if(currentStep && !stepShowPin && !isCheckingLockState && !hasCheckFailed && currentStep.id !== 'mode-select' && currentStep.id !== 'parking-mode-select') {
  <div class="row">
    @if(showPreviousButton) {
    <div class="col-6">
      <button mat-raised-button color="accent" class="mw-160" (click)="previousStep()">
        {{ 'Intellitrailer.Rental.Nuwiel.cmdPrevious' | translate : 'Previous' }}
      </button>
    </div>

    <div class="col-6">
      <button mat-raised-button color="accent" class="mw-160" (click)="next()" [disabled]="!canContinue()">
        {{ 'Intellitrailer.Rental.Nuwiel.cmdNext' | translate : 'Next' }}
      </button>
    </div>
    }
  </div>
  }

  @if(currentStep && !stepShowPin && !isCheckingLockState && !hasCheckFailed && currentStep.id == 'mode-select') {
  <div class="row">
    <div class="col-6">
      <button type="button" mat-raised-button color="accent" (click)="selectMode('BIKE')" class="mw-160">
        {{ 'Intellitrailer.Rental.Nuwiel.Mode1.Bike' | translate : 'Cycling' }}
      </button>
    </div>

    <div class="col-6">
      <button type="button" mat-raised-button color="accent" (click)="selectMode('HAND')" class="mw-160">
        {{ 'Intellitrailer.Rental.Nuwiel.Mode1.Hand' | translate : 'Walking' }}
      </button>
    </div>
  </div>
  }

  @if(currentStep && !stepShowPin && !isCheckingLockState && !hasCheckFailed && currentStep.id == 'parking-mode-select') {
  <div class="row">
    <div class="col-6">
      <button type="button" mat-raised-button color="accent" (click)="selectParkingModeUsed('BIKE')" class="mw-160">
        {{ 'Intellitrailer.Rental.Nuwiel.Mode1.Bike' | translate : 'Cycling' }}
      </button>
    </div>

    <div class="col-6">
      <button type="button" mat-raised-button color="accent" (click)="selectParkingModeUsed('HAND')" class="mw-160">
        {{ 'Intellitrailer.Rental.Nuwiel.Mode1.Hand' | translate : 'Walking' }}
      </button>
    </div>
  </div>
  }

  @if(stepShowPin && !hasPinFailed) {
  <button mat-raised-button color="accent" (click)="continueNuwiel()">
    {{ 'Intellitrailer.Rental.Nuwiel.ContinueNuwiel1' | translate : 'Next' }}
  </button>
  }

  @if(stepShowPin && hasPinFailed) {
  <button mat-raised-button (click)="retry()">
    {{ 'Intellitrailer.Rental.Nuwiel.Retry' | translate : 'Retry' }}
  </button>
  }

  @if(currentStep && !stepShowPin && isCheckingLockState && currentStep.requiresCheck) {
  <button mat-raised-button color="accent" (click)="continueAfterCheck()">
    {{ ('Intellitrailer.Rental.Nuwiel.ManualContinue1.' + currentStep.id) | translate : getManualContinueText() }}
  </button>
  }

  @if(currentStep && !stepShowPin && hasCheckFailed && currentStep.requiresCheck) {
  <button mat-raised-button color="accent" (click)="retry()">
        {{ 'Intellitrailer.Rental.Nuwiel.Retry' | translate : 'Retry' }}
  </button>
  }
</view-actions>
